// src\themes\lino\components\MainView.tsx
import WidgetsRender, { WidgetItem } from '@/components/main/widgets/WidgetsRender';
import BannerSlider from './BannerSlider';
import { SliderItemFrom } from '@/core/models/slider-model';
import Container from '@/components/shared/Container';

type MainViewProps = {
    slides: SliderItemFrom[];
    widgets?: WidgetItem[];
};

export default async function MainView({ slides, widgets }: MainViewProps) {
    return (
        <>
            <BannerSlider slides={slides} />
            <Container className="mt-12 md:mt-16 space-y-14 md:space-y-20">
                <div className="grid grid-cols-12 gap-x-4 gap-y-10 md:gap-x-8 md:gap-y-14 lg:gap-y-16 lg:gap-x-10">
                    <WidgetsRender widgets={widgets} animateText />
                </div>
            </Container>
        </>
    );
}